
import {  Component,FormPageMixins,appConst } from "@/lib";
import DeclareCustoms from "@/store/modules/shipment/declarecustoms/entity";
import CustomsBox from "@/store/modules/shipment/declarecustoms/customsbox"
@Component
export default class CreateDeclareCustomsView extends FormPageMixins {
  model:DeclareCustoms = new DeclareCustoms();

  async created() {

            Object.assign(this.config,{
            getAction:"shipment/declarecustoms/get",
             labelWidth:220,
            pageTitleL:"Action.Edit",
            okAction:"shipment/declarecustoms/update",
            isRedirectIndex:true

        })
  this.$store.dispatch("system/logistics/getIsTraileLogisticsList");
  }
    get record(){ 
      var tt=this.$store.state.shipment.declarecustoms.editDeclareCustoms;
      return tt
    };
      //??
  get businessGroupList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.businessGroup)
  }
    //??
  get shippingTypeList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.shippingType)
  }
    get transactionList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.transaction)
  }
    get startPortList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.startPort)
  }
    get endPortList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.endPort)
  }
    get countryOfArrivalList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.countryOfArrival)
  }
    get tradingCountryList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.tradingCountry)
  }
    get paymentList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.payment)
  }
  get salesTypeList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.salesType)
  }
//????
  get logisticsList() {
    return this.$store.state.system.logistics.logisticsList;
  }
  //??????
  get customerList() {
  
    var tt=this.$store.state.system.customer.customerList;
    return tt
  }

        //?????????
  get senderList() {
    return this.$store.state.system.sender.senderList;
  }

        //????
  get boxTypeList() {
      return this.getCodeListByCategory(
      appConst.codeCategory.boxType)
  }
   async getpayment(value) {
   
     let response =  await this.$store.dispatch({
            type: "shipment/declarecustoms/getPayment",
            id: value,
          });
          this.$set(this.model,"payment",response)
  }
    openDeclareGroupInfo(value) {     
         this.$router.push({
      name: "declareCustoms.declareGroup",
      query: {id:value}
      ,
    });
    }

  formatTotalVolume(value: string): string {
    if (!value && value !== '0') return '';
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    const fixed = num.toFixed(3);
    return fixed.endsWith('0') ? num.toFixed(2) : fixed;
  }

  parseTotalVolume(value: string): string {
    return (value || '').replace(/,/g, '');
  }
     validatorElement() 
    {
         (this.$refs["form-page"] as any).formValidate();
    }
     invoiceRatioValidator(index) {
        return [
        {required: true, type:'string', message: this.L('app.CustomsDeclarationElement.PleaseInput',this.L('app.DeclareCustoms.BoxTypeQuantity')), trigger: 'blur'},
        {type: "string", validator: (rule:any, value:any, callback:any) => {
                const message = "??????????";
             const messageQuantity = "??????????";
            const messagelogistics = "????????????";
               if (!this.model.customsBoxList[index].boxType) {
                callback(message);
                return;
            }
              if (!this.model.customsBoxList[index].boxQuantity) {
                callback(messageQuantity);
                return;
            }
             if (!this.model.customsBoxList[index].logisticsId&&this.model.customsBoxList[index].boxType!='LCL') {
                callback(messagelogistics);
                return;
            }
            callback();
        }, trigger: 'blur,change'}
        ]
    }

    elementInput(index) {
        (this.$refs["form-modal"] as any).validateField('customsBoxList.' + index + '.boxType')
    }
     addElement() {
        this.model.customsBoxList.push(new CustomsBox);
    }
      get currentUser() {
    return this.$store.state.currentUser.session.user;
  }
 removeInvoice(index) {
    if (this.model.customsBoxList.length > 1) {
      let temp=new Array<CustomsBox>();
      this.model.customsBoxList.forEach((element,idx) => {
        if(idx!==index){
          temp.push(element)
        }
       
      });
      this.model.customsBoxList=temp;
    }
 }
}
